var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _line, _line2, _rect8, _line3, _line4, _rect9, _line5, _line6, _rect0, _line7, _line8, _rect1, _rect10, _circle2, _text, _text2, _rect11, _rect12, _text3, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _rect13, _rect14, _rect15, _rect16, _circle9, _text4, _circle0, _text5, _circle1, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccountsBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 200,
    r: 180,
    fill: "#FEF3C7",
    opacity: 0.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 80,
    width: 160,
    height: 220,
    rx: 8,
    fill: "#FFFFFF",
    stroke: "#2563EB",
    strokeWidth: 3
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 90,
    width: 60,
    height: 8,
    rx: 2,
    fill: "#2563EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 90,
    width: 70,
    height: 8,
    rx: 2,
    fill: "#E5E7EB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 110,
    width: 140,
    height: 6,
    rx: 1,
    fill: "#E5E7EB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 125,
    width: 100,
    height: 6,
    rx: 1,
    fill: "#E5E7EB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 140,
    width: 120,
    height: 6,
    rx: 1,
    fill: "#E5E7EB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 160,
    width: 140,
    height: 15,
    fill: "#DBEAFE"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 160,
    x2: 180,
    y2: 175,
    stroke: "#93C5FD",
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 160,
    x2: 230,
    y2: 175,
    stroke: "#93C5FD",
    strokeWidth: 1
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 175,
    width: 140,
    height: 15,
    fill: "#F9FAFB"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 175,
    x2: 180,
    y2: 190,
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 175,
    x2: 230,
    y2: 190,
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 190,
    width: 140,
    height: 15,
    fill: "#FFFFFF"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 190,
    x2: 180,
    y2: 205,
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 190,
    x2: 230,
    y2: 205,
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 205,
    width: 140,
    height: 15,
    fill: "#F9FAFB"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 180,
    y1: 205,
    x2: 180,
    y2: 220,
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 230,
    y1: 205,
    x2: 230,
    y2: 220,
    stroke: "#E5E7EB",
    strokeWidth: 1
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 235,
    width: 140,
    height: 25,
    fill: "#FEF3C7",
    stroke: "#F59E0B",
    strokeWidth: 2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 242,
    width: 60,
    height: 10,
    rx: 2,
    fill: "#F59E0B"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 260,
    r: 20,
    fill: "#10B981"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 250,
    y: 266,
    fontSize: 12,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "GST")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 160,
    y: 255,
    fontSize: 20,
    fill: "#F59E0B",
    fontWeight: "bold"
  }, "\u20B9")), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 90,
    y: 320,
    width: 60,
    height: 70,
    rx: 6,
    fill: "#1E293B"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 325,
    width: 50,
    height: 25,
    rx: 3,
    fill: "#10B981",
    opacity: 0.3
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 120,
    y: 342,
    fontSize: 14,
    fill: "#10B981",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "888")), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 360,
    r: 6,
    fill: "#475569"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 360,
    r: 6,
    fill: "#475569"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 360,
    r: 6,
    fill: "#475569"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 375,
    r: 6,
    fill: "#475569"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 375,
    r: 6,
    fill: "#475569"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 135,
    cy: 375,
    r: 6,
    fill: "#10B981"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 320,
    width: 80,
    height: 50,
    rx: 6,
    fill: "#2563EB"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 330,
    width: 30,
    height: 20,
    rx: 2,
    fill: "#FCD34D"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 355,
    width: 60,
    height: 4,
    rx: 1,
    fill: "#DBEAFE"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 362,
    width: 40,
    height: 4,
    rx: 1,
    fill: "#DBEAFE"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 195,
    cy: 340,
    r: 15,
    fill: "#F59E0B",
    stroke: "#D97706",
    strokeWidth: 2
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 346,
    fontSize: 14,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "\u20B9")), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 215,
    cy: 355,
    r: 12,
    fill: "#F59E0B",
    stroke: "#D97706",
    strokeWidth: 2
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 215,
    y: 360,
    fontSize: 11,
    fill: "#FFFFFF",
    fontWeight: "bold",
    textAnchor: "middle"
  }, "\u20B9")), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 300,
    cy: 100,
    r: 18,
    fill: "#10B981"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 295 100 L 298 103 L 305 96",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountsBilling);
export default __webpack_public_path__ + "static/media/accounts-billing.0c43d23889fe159028b03143795c0587.svg";
export { ForwardRef as ReactComponent };